import { Component, OnInit, ElementRef, Input } from '@angular/core';
import { DialogService } from "../dialog";
import { DialogComponent } from "../dialog/dialog.component";
import { InPurchasesService } from '../../services/inventory/in-purchases.service';
import { DataService } from '../../services/data.service';
import { InTransactionsService } from '../../../shared/services/inventory/in-transactions.service'
export interface ConfirmModelMobilePDT {
  title: string;
  message: string;
  data: any;
  pdttype: number;
}
@Component({
  selector: 'app-mobilepdt-search',
  templateUrl: './mobilepdt-search.component.html',
  styleUrls: ['./mobilepdt-search.component.css']
})
export class MobilepdtSearchComponent extends DialogComponent<ConfirmModelMobilePDT, boolean> implements ConfirmModelMobilePDT, OnInit {
  title: string;
  message: string;
  loading: boolean = false;
  result: any = { item: [], result: false };;
  rtnData: any;
  data: any;
  selectedRow: number = -1;
  sliceStrat: number = 0;
  sliceEnd: number = 15;
  Unit: string = "";
  fullData: any;
  pdttype: number;
  f: any = {
    Id: 0,
    INVNO: "",
    INVDATE: "",
    Supplier: ""
  };
  private el: ElementRef;
  @Input() onReturn: string;
  constructor(dialogService: DialogService, private ips: InPurchasesService, private ds: DataService, private itr: InTransactionsService) {
    super(dialogService);
    this.fullData = this.data;
  }

  ngOnInit() {
    this.fullData = this.data;
    if (!this.fullData) {
      this.close();
    } else {
      this.loading = true;
    }
  }
  confirm(item) {
    this.result = { item: item, result: true };
    this.close();
  }
  setClickedRow(e) {
    this.selectedRow = e;
    document.getElementById("focus").focus();
  }
  NextBut() {
    if (this.NexbutEnable()) {
      this.fullData = this.data;
      this.sliceEnd = Number(this.sliceEnd) + 15
      this.selectedRow = 0
    }
  }
  PreBut() {
    if (!this.PrebutEnable()) {
      this.fullData = this.data;
      this.sliceEnd = Number(this.sliceEnd) - 15
      this.selectedRow = 0
    }
  }
  NexbutEnable(): boolean {
    return this.fullData.length > this.sliceEnd
  }
  PrebutEnable(): boolean {
    return this.sliceEnd < 16
  }
  ItesmSearch(e, type) {
    if (e.keyCode == 13 && e.which == 13) {
      this.fullData = this.data;
      switch (type) {
        case "INVNO":
          this.f.INVNO = e.target.value;
          break;
        case "INVDATE":
          this.f.INVDATE = e.target.value;
          break;
        case "Supplier":
          this.f.Supplier = e.target.value;
          break;
      }
      this.selectedRow = 0;
      var Filterdata: any = {
        LocId: this.ds.Settings.LocationId,
        RequestedList: {
          Start: 0,
          FiterText: "",
          Limit: 1000,
          ItemTypeId: this.ds.Settings.ItemTypeId,
          CAType: this.ds.Settings.CAType
        },
        FilterData: this.f,
      }
      if (this.pdttype == 1) {
        this.ips.MobilePDTSearch(Filterdata).subscribe(res => {
          if (res.Success) {
            this.fullData = res.data
          }
        });
      }
      if (this.pdttype == 2) {
        this.ips.MobilePDTSearchPRN(Filterdata).subscribe(res => {
          if (res.Success) {
            this.fullData = res.data
          }
        });
      }
      if (this.pdttype == 3) {
        this.itr.Get_PDTDamageSearch(Filterdata).subscribe(res => {
          if (res.Success) {
            this.fullData = res.data
          }
        });
      }
    } else if (e.keyCode == 40 && e.which == 40) {
      document.getElementById("focus").focus();
      this.selectedRow = 0;
    }
  }
  scroll(event: KeyboardEvent) {
    //up 38 down 40
    event.preventDefault();
    if (event.keyCode === 40) {
      if (this.selectedRow > 13) {
        this.NextBut();
      } else {
        this.selectedRow++;
      }
    } else if (event.keyCode === 38) {
      if (this.selectedRow < 1) {
        this.PreBut();
      } else {
        this.selectedRow--;
      }
    } else if (event.keyCode === 13) {
      this.selecedItem();
    }
    else return;
  }
  selecedItem() {
    var abc = document.getElementsByClassName("selectedItesmsaerch786")[0].getElementsByClassName("bkd")[0].innerHTML;
    var bcd = this.fullData.find(x => x.INVNO == abc);
    this.confirm(bcd);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/mobilepdt-search/mobilepdt-search.component.ts